import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#6D28D9",
        secondary: "#A78BFA",
        accent: "#F472B6",
        background: "#F7F5FF"
      }
    }
  }
});

